import React, { useEffect, useState } from "react";
import ProductDetailImageEnlarge from "./ProductDetailImageEnlarge";
import Modal3D from "../../../../component/custom/3DModal";
import ProductCompareSelection from "../../../ProductCompare/ProductCompareSelection";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import DisplayLifeCycleRisk from "src/component/custom/DisplayLifeCycleRisk";
import { isArray } from "underscore";
import { useProductStore } from "src/hooks/product";
import ShowMoreLess from "../../../../component/custom/ShowMoreLess";
import ProductLegends from "src/pages/ProductListing/ProductLegends";
import System from "src/helper/system";
import DesignHubModalPopUp from "src/pages/ProductListing/DesignHubModalPopUp";
import Helper from "../../../../helper/Helper";
import { __remove } from "src/store/axios_indicator";
import Constants from "src/helper/Constants";
import liveAuth from "src/helper/liveAuth";

const TopProductDetail = (props) => {
  const { productDetail } = props
  const [__check] = useAxiosIndicatorCheck();
  const [
    { designHubData, model_ProductCompare_data },
    { fetch_product_images_list, fetch_alternative_product_count, get_all_design_data, check_designs, fetch_product_document_list },
    { },
  ] = useProductStore();
  const [isDesignAvailable, setIsDesignAvailable] = useState(false);
  const [designIdsArray, setDesignIdsArray] = useState([]);
  const [designData, setDesignData] = useState();
  const [showDesignHubModal, setShowDesignHubModal] = useState(false);

  const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
  const { systemModules: { PDP } } = Constants
  const { avUserInfoData: { speedBoatName, speedBoatNameLower } } = System
  const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)

  useEffect(() => {
    checkIfDesignsAvailable();
  }, [designHubData?.availableDesigns]);

  const fetchDesignData = async () => {
    if (isDesignAvailable && designIdsArray.length > 0) {
      const params = {
        itemNumberArray: designIdsArray,
        speedBoat: speedBoatName,
      };

      const results = await get_all_design_data(params);
      if (results && Object.keys(results?.data).length > 0) {
        setDesignData(results?.data);
      }
    }
    setShowDesignHubModal(true);
    System.setEvars('', 'Design Button Click from PDP,PLP')
  };

  const checkIfDesignsAvailable = async () => {
    designHubData?.availableDesigns.filter(v => {
      if (v.itemNumber === productDetail?.ItemNumber && v.isDesignsAvailable) {
        setIsDesignAvailable(true);
        setDesignIdsArray(v?.designIds);
      } else {
        setIsDesignAvailable(false);
      }
    }
    );
  };

  useEffect(() => {
    async function fetchHere() {
      if (productDetail) {
        await checkDesignsFromServer();
        await getImageData();
        await getAlternativeProductCountByVariantNumber();
        await getProductDocumentCount();
      }
      __remove('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')
      // if (!monitorFunctionCall) {
      //   System.monitorJSDx()
      //   setMonitorFunctionCall(true)
      // }
    }

    fetchHere();
  }, [productDetail]);

  const checkDesignsFromServer = async () => {
    if (productDetail) {
      let itemNumbers = [];
      itemNumbers.push(productDetail.ItemNumber)

      await check_designs(itemNumbers);
    }
  };

  const getImageData = async () => {
    if (productDetail?.ItemNumber) {
      let ItemNumber = productDetail?.ItemNumber;
      let params = {};
      params.filter = "ItemNum  eq " + "'" + ItemNumber + "'";
      params.top = 100;
      params.variantAssetSearchType = PDP;
      await fetch_product_images_list(params);
    }
  };

  const getAlternativeProductCountByVariantNumber = async () => {
    if (productDetail?.ItemNumber) {
      await fetch_alternative_product_count({
        ItemNum: productDetail?.ItemNumber,
      });
    }
  };

  const getProductDocumentCount = async () => {
    if (productDetail?.ItemNumber) {
      let ItemNumber = productDetail?.ItemNumber;
      await fetch_product_document_list({
        filter: "ItemNum  eq " + "'" + ItemNumber + "'", top: 0, orderby: ""
      });
    }
  };

  return (
    <>
      {productDetail && (
        <>
          <h1 className="mt-0 mb-2 font-24 font-apecru lh-normal">
            {productDetail?.ERPMFRPartNumber ? productDetail.ERPMFRPartNumber : ""}
          </h1>
          <ShowMoreLess single_product={productDetail} />

          <div className="product-detail-info">
            <div className="bs5 row">
              <ProductDetailImageEnlarge eRPMFRPartNumber={productDetail.ERPMFRPartNumber} />
              <div className="col-xl-7 col-lg-6 col-md-6 mob-show-productdetail">
                <div className="product-detail-content">
                  <div className="info-list">

                    {productDetail?.ManufacturerLogo && (
                      <a
                        href={`/${speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(productDetail?.ManufacturerName?.toLowerCase())}/`}
                      >
                        <img
                          className="my-3"
                          alt={`Official logo for ${productDetail?.ManufacturerName}`}
                          title={`Official logo for ${productDetail?.ManufacturerName}`}
                          style={{ height: "20px" }}
                          src={productDetail?.ManufacturerLogo}
                        />
                      </a>
                    )}

                    <div className="info-item">
                      <b className="me-1">Manufacturer:</b>
                      <a
                        href={`/${speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(productDetail?.ManufacturerName?.toLowerCase())}/`}
                        className="cursor-pointer text-blue"
                        alt={`Official logo for ${productDetail?.ManufacturerName}`}
                        title={`Official logo for ${productDetail?.ManufacturerName}`}
                      >
                        {productDetail &&
                          Helper.valueIsNotNull(productDetail?.ManufacturerName)
                          ? productDetail.ManufacturerName
                          : ""}
                      </a>
                    </div>
                    {productDetail.categoryListing && isArray(productDetail.categoryListing) &&
                      productDetail.categoryListing.length > 0 && (
                        <div className="info-item">
                          <b>Product Category: </b>
                          <span>
                            {productDetail.categoryListing.map((v, i) => (
                              // bellow href to redirect to category page is commented and url is being retrieved from the object itself.
                              <a href={`/${speedBoatName}${v.url}/`}
                                key={i}>
                                {v.value}
                                {i !== productDetail.categoryListing.length - 1 ? "," : ""}{" "}
                              </a>
                            ))}
                          </span>
                        </div>
                      )}
                    <div className="info-item">
                      <b className="me-1">Avnet Manufacturer Part #: </b>
                      <span>
                        {productDetail?.ManufacturerPartNumber
                          ? productDetail.ManufacturerPartNumber : ""}
                      </span>
                    </div>
                    {productDetail?.AliasPartNumberSecondarySupplier &&
                      <div className="info-item">
                        <b className="me-1">Secondary Manufacturer Part#: </b>
                        <span>
                          {productDetail.AliasPartNumberSecondarySupplier}
                        </span>
                      </div>
                    }

                    {isInternalUser && productDetail?.ERPPartNumber &&
                      <div className="info-item">
                        <b className="me-1">ERP Part #: </b>
                        <span>
                          {productDetail?.ERPPartNumber}
                        </span>
                      </div>
                    }
                  </div>
                  <div className="bs5 row g10 mt-2 mb-0 align-items-center">
                    <div className="col-auto mb-3 md-sm-0 pe-0">
                      <div className="info-capsule mt-1">
                        <div className="info-capsule-item">
                          <ProductCompareSelection
                            single_product={productDetail}
                            model_ProductCompare_data={model_ProductCompare_data}
                          />
                        </div>
                        {Helper.valueIsNotNull(productDetail?.DatasheetUrl)
                          && (
                            <a rel="nofollow"
                              href={productDetail?.DatasheetUrl}
                              target="_new"
                              className="info-capsule-item"
                            >
                              <img className="img-fluid" alt="Datasheet"
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVHgBnZIxS8NAFMf/KYHgINzSRZCm3yCbY1v8Ck4uVgTnZnPTfgTBRZe4iEO0dHRxctTBLyCJi4OD3qBOwvW99lrS47hc++DPS17e/3cvLwGAgqQsivUzzs5QDoDygdQBnJAQ7hhWrmNSuQogMwwCnhOc6+YDo/5OGpvNDQvg1TgZSZIgz/OOUuqMlNQBBIxxGTBqvXT3n09O+dZngjEsC7OFCbjWJ7DaWkNfAC8vJbVIPGqhc8cFCCtjD7RhoGu8hz5qIsDsT5tDFgsSQiDLMvxuK4SbEW6+Hqb14/ae3GhEcre5UwZB0ONXKLVnabtSSqRpip//P1x+jqaZdVXcia2oyS2H8An67jGZvntPR4p1//FYcA2rBBm6F2+365krkL7NPAEy0HwqftdBcQAAAABJRU5ErkJggg" />
                              <span className="datasheet-label">Datasheet</span>
                            </a>
                          )}

                        {isDesignAvailable && (
                          <a href="#" data-toggle="modal" data-target="#designhubpopup" className="info-capsule-item"
                            onClick={() => fetchDesignData()}
                          >
                            <div className="designshub_img icon" />
                            <span className="datasheet-label">Designs</span>
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="col-auto m-b-15">
                      <Modal3D value={productDetail} />
                    </div>
                  </div>

                  <div className="legend-list legend-list-horizontal d-flex">
                    <ul>
                      <ProductLegends
                        single_product={productDetail}
                        onlyIconTitle={true} />

                      <li>
                        <span className="legend-list-item d-inline-flex">
                          <DisplayLifeCycleRisk
                            single_product={productDetail} />
                        </span>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>

              {designData && (
                <DesignHubModalPopUp
                  showDesignHubModal={showDesignHubModal}
                  setShowDesignHubModal={setShowDesignHubModal}
                  productDetail={productDetail}
                  designData={designData}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TopProductDetail;
